import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageService } from '../../../core/services/storage/storage.service';
import { UserService } from '../user/user.service';

@Injectable()
export class RouteGuardService {
    public user: any;

    constructor(private router: Router,
                private userService: UserService,
                private storageService: StorageService,
    ) {

    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.userService.getCurrentUser()
                   .pipe(
                       map((currentUser: any) => {
                           if (state) {
                               if (state.url.search('manage-users') !== -1 && !currentUser.isAdmin) {
                                   (async () => await this.router.navigate(['access-denied']))();
                               } else if (state.url.search('end-of-day-reports') !== -1 && currentUser.isGuest) {
                                   (async () => await this.router.navigate(['access-denied']))();
                               } else if (state.url.search('manage-locations') !== -1 && !currentUser.isAdmin) {
                                   (async () => await this.router.navigate(['access-denied']))();
                               } else if (state.url.search('rewardship') !== -1 && currentUser.isGuest) {
                                   (async () => await this.router.navigate(['access-denied']))();
                               } else if (state.url.search('notify-templates') !== -1 && !currentUser.isAdmin) {
                                   (async () => await this.router.navigate(['access-denied']))();
                               } else if (state.url.search('cost-estimator') !== -1 && currentUser.isGuest) {
                                   (async () => await this.router.navigate(['access-denied']))();
                               }
                           }

                           return true;
                       }),
                   );
    }

}
